export function serverResponseToJSON(responseText: string, methodName: string) {
    return window['priResponse']?.serverResponseToJSON?.(responseText, methodName);
}
